import httpService from '@/services/httpService'
import { isEqual, uniqWith } from 'lodash'

export const types = {
  CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD: 'keyword-census/CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD',
  UPDATE_TABLE_FILTERS: 'keyword-census/UPDATE_TABLE_FILTERS'
}
const state = {
  lastSelectedBulkUpdateField: 'mappedUrl',
  tableFilters: []
}

const mutations = {
  [types.CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD]: function (state, lastSelectedBulkUpdateField) {
    state.lastSelectedBulkUpdateField = lastSelectedBulkUpdateField
  },
  [types.UPDATE_TABLE_FILTERS]: function (state, tableFilters) {
    state.tableFilters = tableFilters
  }
}

const actions = {
  async getUrlOpts ({ commit, dispatch }, clientId) {
    const response = await httpService.get(`/keyword-census/url-opts/${clientId}`)
    return response.data
  },
  async getOpts ({ commit, dispatch }, clientId) {
    const response = await httpService.get(`/keyword-census/opts/${clientId}`)
    return response
  },
  async postBulkUpdate ({ commit, dispatch }, { clientId, form }) {
    form = JSON.stringify(form)
    return httpService.post(`/keyword-census/bulk-update/${clientId}`, { form },
      { successMessage: 'Keywords successfully updated', raiseError: true })
  },
  async postKeywords ({ commit, dispatch }, { clientId, form }) {
    form = JSON.stringify(form)
    // return httpService.post(`/keyword-census/keywords/${clientId}`, { form },
    //   { successMessage: 'Keywords successfully added', raiseError: true })
    return httpService.post(`/keyword-census/keywords/${clientId}`, { form },
      { raiseError: true })
  },
  async postUrls ({ commit, dispatch }, { clientId, form }) {
    form = JSON.stringify(form)
    return httpService.post(`/keyword-census/urls/${clientId}`, { form },
      { successMessage: 'Completed request', raiseError: true })
  },
  async updateField ({ commit, dispatch }, { form }) {
    form = JSON.stringify(form)
    return httpService.patch('/keyword-census/update-field', { form },
      { successMessage: 'Item successfully updated', raiseError: true })
  },
  async getFilterFields ({ commit, dispatch }, { clientId, data }) {
    const params = { data: JSON.stringify(data) }
    return httpService.get(`/keyword-census/filter-data/${clientId}`, { params })
  },
  async getAggregates ({ commit, dispatch }, { filters, clientId }) {
    const form = JSON.stringify(filters)
    const response = await httpService.post(`/keyword-census/aggregates/${clientId}`, { form })
    return response
  },
  async postTableView ({ commit, dispatch }, { clientId, form, type }) {
    form = JSON.stringify(form)
    const response = await httpService.post(`/keyword-census/table-view/${clientId}`, { form, type })
    return response
  },
  async getTableView ({ commit, dispatch }, { clientId, data }) {
    const params = { data: data }
    const response = await httpService.get(`/keyword-census/table-view/${clientId}`, { params })
    return response
  },
  async patchTableView ({ commit, dispatch }, { clientId, details, tableViewId }) {
    const form = JSON.stringify({ details, tableViewId })
    const response = await httpService.patch(`/keyword-census/table-view/${clientId}`, { form })
    return response
  },
  async deleteTableView ({ commit, dispatch }, { clientId, tableViewId }) {
    const config = {
      params: {
        id: tableViewId
      }
    }
    const response = await httpService.delete(`/keyword-census/table-view/${clientId}`, config)
    return response
  },
  async getSavedViews ({ commit, dispatch }, { clientId, userId, type }) {
    const params = { clientId, type }
    const response = await httpService.get(`/keyword-census/table-view/saved-views/${userId}`, { params })
    return response.data
  },
  async getKeywordsDiscovery(_, { clientId, keyword }) {
    const params = { clientId, keyword }
    const response = await httpService.get(`/keyword-census/discovery`, { params })

    return response
  },
  async postKeywordsDiscovery(_, { clientId, urlId, keywords, url }) {
    const params = { clientId, urlId, keywords, url }
    const response = await httpService.post(`/keyword-census/discovery`, params, { isFormData: true })
    return response
  },
  changeLastSelectedBulkUpdateField ({ commit }, lastSelectedBulkUpdateField) {
    commit(types.CHANGE_LAST_SELECTED_BULK_UPDATE_FIELD, lastSelectedBulkUpdateField)
  },
  updateTableFilters ({ commit }, { advancedFilters, headerFilters }) {
    headerFilters = headerFilters.map(filter => ({ ...filter, isHeaderFilter: true }))
    advancedFilters = advancedFilters.map(filter => ({ ...filter, isHeaderFilter: false }))
    let tableFilters = [...advancedFilters, ...headerFilters]
    tableFilters = tableFilters.reduce((previous, current) => {
      // filter must have all fields set
      const filterIsMissingFields = !current.field || !current.type || !current.value
      const valueIsEmptyArray = Array.isArray(current.value) && !current.value.length
      if (filterIsMissingFields || valueIsEmptyArray) {
        return previous
      }
      // clean up into consistent object
      current = {
        field: current.field,
        type: current.type,
        value: current.value,
        isHeaderFilter: current.isHeaderFilter
      }
      // 'in' filters must have values of type Array
      if (current.type === 'in' && !Array.isArray(current.value)) {
        current.value = current.value.split(',').map(val => val.trim())
      }

      if (current.type === 'in') {
        for (let i = 0; i < current.value.length; i++) {
          const newFilter = {
            field: current.field,
            type: 'in',
            value: [current.value[i]],
            isHeaderFilter: current.isHeaderFilter
          }
          const exists = previous.some(obj => isEqual(obj, newFilter))
          if (!exists) {
            previous.push(newFilter)
          }
        }
      }
      // remove duplicates
      const includesFilter = previous.some(obj => isEqual(obj, current))
      if (current.type !== 'in' && !includesFilter) {
        previous.push(current)
      }
      return previous
    }, [])

    advancedFilters = tableFilters.filter(filter => !filter.isHeaderFilter)
    tableFilters = tableFilters.filter(filter => filter.isHeaderFilter)
    advancedFilters.forEach(filter => {
      const filterExists = tableFilters.some(obj => {
        return isEqual({ ...obj, isHeaderFilter: null }, { ...filter, isHeaderFilter: null })
      })
      if (!filterExists) {
        tableFilters.push(filter)
      }
    })

    commit(types.UPDATE_TABLE_FILTERS, tableFilters)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
